import axios from "axios";

export const APIURL = process.env.REACT_APP_API_ENDPOINT;

export const CATEGORY_URL = APIURL+"/category/";

// CREATE =>  POST: create a new category to the server
export function createCategory(category) {
	const result = axios.post(`${CATEGORY_URL}create`, category);
	return result
}

// READ
export function getAllCategories() {
  return axios.get(CATEGORY_URL);
}

export function getCategoryById(categoryId) {
	const result = axios.get(`${CATEGORY_URL}find/${categoryId}`);
	return result;
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findCategories(queryParams) {
  const result = axios.post(`${CATEGORY_URL}find`, { queryParams });
  return result;
}

// UPDATE => PUT: update the category on the server
export function updateCategory(category) {
  return axios.post(`${CATEGORY_URL}update/${category.id}`, { category });
}

// UPDATE Status
export function updateStatusForCategories(ids, status) {
  return axios.post(`${CATEGORY_URL}updateStatusForCategories`, {
    ids,
    status
  });
}

// UPDATE single Status
export function updateStatusForCategory(id, status) {
  return axios.post(`${CATEGORY_URL}updateStatusForCategory`, {
    id,
    status
  });
}

export function createCategoryByName(name) {
  return axios.post(`${CATEGORY_URL}createCategory`, {
    name
  });
}

export function updateRecordForCategory(id,name) {
  return axios.post(`${CATEGORY_URL}updateRecordForCategory`, { id, name});
}

// DELETE => delete the category from the server
export function deleteCategory(id) {
 return axios.post(`${CATEGORY_URL}delete`, { id });
}

// DELETE Categories by ids
export function deleteCategories(ids) {
  return axios.post(`${CATEGORY_URL}deleteCategories`, { ids });
}
